<template>
  <van-row class="white-page-bg payment-cb">
    <van-col span="24">
      <info-message class="itserve-center place-content-center">
        <img
          src="@/assets/images/action_canceled.png"
          alt="cancel-action"
        /><br />
        {{ $t("pay.cardNotAdded") }}
      </info-message>
    </van-col>
  </van-row>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";
export default {
  components: { InfoMessage },
  name: "Cancel",
};
</script>
<style scoped></style>
